// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import DataViewer from '../core/data-viewer';
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-ivi-request.scss';

const servicesDataKey = 'mediaItemIvi';

class IVIRequest extends Component {
    getDataViewerProps() {
        return {
            className: 'mediaitem-ivi-request--data-viewer',
            defaultExpandKeys: ['FWCoreContainer'],
            mode: 'xml',
            searchData: this.getXmlData(),
        };
    }

    getMediaItemGuid() {
        const {routerParams} = this.props;

        return routerParams.guid;
    }

    getPaginationProps() {
        return {
            maxResults: 50000,
            maxPages: 9,
        };
    }

    getRecordDetailsProps() {
        return {
            blacklistKeys: ['xml'],
            className: 'mediaitem-ivi-request--record-details',
            whitelistKeys: ['guid'],
        };
    }

    getXmlData() {
        const {searchData} = this.props;

        return [get(searchData, '0.xml')];
    }

    renderDataViewer() {
        const {searchData} = this.props;

        return searchData.length ? (
            <DataViewer {...this.getDataViewerProps()} />
        ) : (
            <div className="mediaitem-ivi-request--no-items">IVI request not available for this Media Item.</div>
        );
    }

    render() {
        const {fetching, searchData} = this.props;

        return this.getMediaItemGuid() ? (
            <div className="mediaitem-ivi-request">
                <div className="mediaitem-ivi-request--content">
                    <div className="mediaitem-ivi-request--title">Media Item IVI Request</div>
                    <RecordDetails {...this.getRecordDetailsProps()} searchData={searchData} />
                    <div className="mediaitem-ivi-request--title">IVI Request</div>
                    {this.renderDataViewer()}
                    <Loading loading={fetching} />
                </div>
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

IVIRequest.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(IVIRequest, servicesDataKey);
